module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ki-32000b051bb6bb9ee78500c639023c1a.svg";